import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const whatIsSteps = [
  {
    icon: "ri-hand-coin-line",
    title: "認購",
    desc: "我手上有與大廠對接好的實體產品，產品一律放在此平台上，妳只需點擊產品、決定組數、支付成本，即可把這批貨的所有權買下來。",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "代銷",
    desc: "你們不用囤貨，也不用自己賣，一切都由我團長代銷到國內外各大通路。",
  },
  {
    icon: "ri-bank-line",
    title: "利潤入帳",
    desc: "貨賣掉了，妳身為貨主，利潤跟成本自然就結算給妳。",
  },
];

const whyChooseSteps = [
  {
    icon: "ri-shield-check-line",
    title: "專業審核，妳負責收成",
    desc: "所有的產品都是經過團長跟團隊嚴格把關，確認有市場、有通路才會放上平台讓你們認購。",
  },
  {
    icon: "ri-home-smile-line",
    title: "零囤貨壓力，真正的優雅",
    desc: "妳不需要家裡堆滿貨，也不用去求人買產品，妳只需要做「貨主」，剩下的流程都由我來處理。",
  },
  {
    icon: "ri-award-line",
    title: "誠信第一，認貨不認人",
    desc: "每一筆認購在系統裡都有紀錄，貨賣出去了利潤就是妳的，規矩清清楚楚。",
  },
];

const guaranteeItems = [
  {
    icon: "ri-time-line",
    title: "固定結算，準時入帳",
    desc: "認購不是付完成本後空等，我們有明確的銷售與結算週期，在你認購的1~2天內即可銷售完畢，返款入帳。",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "資產透明，隨時查看",
    desc: "透過這套電商系統，妳可以隨時追蹤自己貨權的銷售進度，不用擔心資訊不透明。",
  },
  {
    icon: "ri-shield-star-line",
    title: "專業領航，風險規避",
    desc: "每一項產品都經過團隊嚴格篩選，確保是市場熱銷貨才開放認購。妳負責參與，我負責讓這批貨在各大通路流轉。",
  },
];

const communityItems = [
  {
    icon: "ri-hand-heart-line",
    title: "一對一手把手教學",
    desc: "不只是認購平台，更有一個互相成長的社群，遇到任何操作或觀念上的問題，直接在群組提出，大家一起分享交流。",
  },
  {
    icon: "ri-vip-diamond-line",
    title: "第一手資訊卡位",
    desc: "成為VIP後，妳將擁有第一時間參與大廠熱門貨權認購的權利，在電商的世界裡，資訊差就是妳的財富。",
  },
  {
    icon: "ri-rocket-line",
    title: "開啟妳的斜槓人生",
    desc: "認購只是一個開始，透過這套成熟的代銷系統，讓妳在不用囤貨、不用自己賣的情況下，優雅地擁有一份持續性的利潤。",
  },
];

const howToSteps = [
  {
    step: "Step 1",
    icon: "ri-vip-crown-line",
    title: "成為VIP",
    desc: "參與投標來開啟你的VIP權限，決定你日後的組數。",
  },
  {
    step: "Step 2",
    icon: "ri-shopping-cart-line",
    title: "平台選貨",
    desc: "登入這個平台系統，挑選你想認購的產品以及決定組數。",
  },
  {
    step: "Step 3",
    icon: "ri-wallet-3-line",
    title: "支付成本",
    desc: "挑選完後點擊下單並支付成本，等待產品銷售完畢利潤成本進帳。",
  },
];

export default function GuidePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        {/* Hero */}
        <section className="relative h-[280px] md:h-[360px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-amber-50 to-orange-50" />
          <div className="relative z-10 text-center px-6">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              認購指南
            </h1>
            <p className="text-base md:text-lg text-gray-500 max-w-xl mx-auto">
              了解認購批發的完整流程，新手也能輕鬆上手
            </p>
          </div>
        </section>

        {/* 1. 什麼是認購 */}
        <section className="py-14 md:py-20 px-6 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-amber-50 text-amber-600 text-xs font-medium mb-3">
                認購批發
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                1. 什麼是認購？
              </h2>
              <p className="mt-3 text-gray-500 text-base md:text-lg">
                認購就是買賣貨權，一起合夥做生意
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {whatIsSteps.map((s) => (
                <div
                  key={s.title}
                  className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-gray-50/80 border border-gray-100"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-amber-50 text-amber-500 mb-5">
                    <i className={`${s.icon} text-2xl`} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 2. 如何參與認購 */}
        <section className="py-14 md:py-20 px-6 lg:px-12 bg-gray-50/60">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-emerald-50 text-emerald-600 text-xs font-medium mb-3">
                參與流程
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                2. 如何參與認購？
              </h2>
              <p className="mt-3 text-gray-500 text-base md:text-lg">
                三步驟開啟你的認購之旅
              </p>
            </div>

            <div className="space-y-5">
              {howToSteps.map((s, idx) => (
                <div
                  key={s.step}
                  className="flex flex-col sm:flex-row items-start sm:items-center gap-5 p-5 md:p-6 rounded-xl bg-white border border-gray-100"
                >
                  <div className="flex items-center gap-4 shrink-0">
                    <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-500">
                      <i className={`${s.icon} text-2xl`} />
                    </div>
                    <span className="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                      {s.step}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1">
                      {s.title}
                    </h3>
                    <p className="text-sm text-gray-500 leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 3. 為什麼要跟著團長做？ */}
        <section className="py-14 md:py-20 px-6 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-rose-50 text-rose-600 text-xs font-medium mb-3">
                團隊優勢
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                3. 為什麼要跟著團長做？
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {whyChooseSteps.map((s) => (
                <div
                  key={s.title}
                  className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-gray-50/80 border border-gray-100"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-rose-50 text-rose-500 mb-5">
                    <i className={`${s.icon} text-2xl`} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 4. 認購保障與週期 */}
        <section className="py-14 md:py-20 px-6 lg:px-12 bg-gray-50/60">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-sky-50 text-sky-600 text-xs font-medium mb-3">
                保障機制
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                4. 認購保障與週期
              </h2>
            </div>

            <div className="space-y-5">
              {guaranteeItems.map((s, idx) => (
                <div
                  key={s.title}
                  className="flex flex-col sm:flex-row items-start sm:items-center gap-5 p-5 md:p-6 rounded-xl bg-white border border-gray-100"
                >
                  <div className="flex items-center gap-4 shrink-0">
                    <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-sky-50 text-sky-500">
                      <i className={`${s.icon} text-2xl`} />
                    </div>
                    <span className="text-xs font-semibold text-sky-600 bg-sky-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                      保障 {idx + 1}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1">
                      {s.title}
                    </h3>
                    <p className="text-sm text-gray-500 leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. 專屬社群與資源共享 */}
        <section className="py-14 md:py-20 px-6 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-violet-50 text-violet-600 text-xs font-medium mb-3">
                社群資源
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                5. 專屬社群與資源共享
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {communityItems.map((s) => (
                <div
                  key={s.title}
                  className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-gray-50/80 border border-gray-100"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-violet-50 text-violet-500 mb-5">
                    <i className={`${s.icon} text-2xl`} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-14 md:py-20 px-6 lg:px-12 bg-amber-50/40">
          <div className="max-w-xl mx-auto text-center">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
              準備好開始認購了嗎？
            </h3>
            <p className="text-gray-500 mb-8 text-sm md:text-base">
              前往產品列表挑選心儀商品，開啟你的認購批發之旅
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/products"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-lg bg-amber-500 text-white text-sm font-medium hover:bg-amber-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-shopping-bag-line" />
                瀏覽產品
              </Link>
              <Link
                to="/register"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-lg border border-gray-200 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap"
              >
                <i className="ri-user-add-line" />
                註冊會員
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}